import { useEffect, useState } from 'react';
import './OverlayWords.css';

interface OverlayWordsProps {
  words: string[];
  isActive: boolean;
}

interface WordPosition {
  word: string;
  x: number;
  y: number;
  delay: number;
  size: number;
}

export function OverlayWords({ words, isActive }: OverlayWordsProps) {
  const [positions, setPositions] = useState<WordPosition[]>([]);

  useEffect(() => {
    if (isActive && words.length > 0) {
      const newPositions = words.map((word, i) => ({
        word,
        x: 20 + Math.random() * 60,
        y: 15 + Math.random() * 70,
        delay: i * 0.15,
        size: 0.8 + Math.random() * 0.6
      }));
      setPositions(newPositions);
    } else {
      setPositions([]);
    }
  }, [words, isActive]);

  if (!isActive || positions.length === 0) return null;

  return (
    <div className="overlay-words">
      {positions.map((pos, i) => (
        <span
          key={`${pos.word}-${i}`}
          className="overlay-words__word"
          style={{
            left: `${pos.x}%`,
            top: `${pos.y}%`,
            animationDelay: `${pos.delay}s`,
            fontSize: `${pos.size}rem`
          }}
        >
          {pos.word}
        </span>
      ))}
    </div>
  );
}
